import React from "react";

export const CasesInformational = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 4.66667H6V3.33333H7.33333M7.33333 10H6V6H7.33333M6.66667 0C5.79119 0 4.92428 0.172438 4.11544 0.50747C3.30661 0.842501 2.57168 1.33356 1.95262 1.95262C0.702379 3.20286 0 4.89856 0 6.66667C0 8.43478 0.702379 10.1305 1.95262 11.3807C2.57168 11.9998 3.30661 12.4908 4.11544 12.8259C4.92428 13.1609 5.79119 13.3333 6.66667 13.3333C8.43478 13.3333 10.1305 12.631 11.3807 11.3807C12.631 10.1305 13.3333 8.43478 13.3333 6.66667C13.3333 5.79119 13.1609 4.92428 12.8259 4.11544C12.4908 3.30661 11.9998 2.57168 11.3807 1.95262C10.7617 1.33356 10.0267 0.842501 9.21789 0.50747C8.40905 0.172438 7.54215 0 6.66667 0Z"
        fill="#00FFFF"
      />
    </svg>
  );
};

export default CasesInformational;
